<app-multi-select-dropdown
    context="division-filter assets"
    [dropdownLabel]="divisionLabel"
    [options]="divisions$ | async"
    (submitDropdownMultiSelect)="submitDropdownMultiSelect($event)"
>
</app-multi-select-dropdown>